import { useCallback, useMemo } from "react";
import { CategorizationWithConfig } from "../../configMap/interfaces/category";

interface SharedMetadataCategorizationData {
  handleFocus: () => void;
  handleSearch: (value: string) => void;
  isIncomplete: boolean;
  isCategorizationDisabledByParent: boolean | undefined;
}

/**
 * Shared hook for common metadata categorization logic used by both Dynamic and Fixed types
 */
const useMetadataCategorization = (
  categorizationWithConfig: CategorizationWithConfig,
  categorizationData: SharedMetadataCategorizationData,
  disabled: boolean,
) => {
  const searchOnFocus = useMemo(
    () => categorizationWithConfig.categorization.search?.fetchOnFocus,
    [categorizationWithConfig.categorization.search?.fetchOnFocus],
  );

  const onFocus = useCallback(() => {
    categorizationData.handleFocus();

    if (searchOnFocus) {
      categorizationData.handleSearch("");
    }
  }, [categorizationData, searchOnFocus]);

  const className = useMemo(() => {
    if (disabled) {
      return "classifier-item__select-disabled";
    }

    let classes = "";
    if (categorizationData.isIncomplete) {
      classes += "classifier-item__select-is-incomplete";
    }
    if (categorizationData.isCategorizationDisabledByParent) {
      classes += " classifier-item__select-no-parent-value";
    }

    return classes;
  }, [
    disabled,
    categorizationData.isIncomplete,
    categorizationData.isCategorizationDisabledByParent,
  ]);

  return {
    onFocus,
    className,
  };
};

export default useMetadataCategorization;
